import { queryKeys } from '../../lib/queryKeys';
import type { RequestError } from '../../shared';
import { observableToPromise } from '../../shared/observableToPromise';
import { type CustomRoleResponse, getAccountCustomRoles } from '../api';
import type { Account } from '../model';

import { useAccountQuery } from './useAccountQuery';

export function useCustomRoles(account: Account | null | undefined) {
  return useAccountQuery<CustomRoleResponse | null, RequestError>(
    account ? (queryKeys.accounts.customRoles(account._id) as readonly unknown[]) : ['accounts', 'custom-roles', null],
    ({ signal }) => (account ? observableToPromise(getAccountCustomRoles(account), signal) : Promise.resolve(null)),
    account,
  );
}
